import React from "react";
import PropTypes from "prop-types";
import { Tooltip, Button } from "reactstrap";

class HierarchyTreeTooltip extends React.Component {
  render() {
    return (
      <Tooltip
        arrowClassName="border-light"
        autohide={false}
        innerClassName="d-flex flex-column align-items-center bg-white shadow"
        isOpen={this.props.isOpen}
        target={`id_${this.props.keyId}`}
      >
        {this.props.options.map(option => (
          <Button
            style={{ maxWidth: "150px", whiteSpace: "pre-wrap" }}
            className="btn btn-outline-primary d-block my-1 w-100 text-black"
            key={`${option.name}`}
            onClick={this.props.functions[option.name]}
            data-id={this.props.keyId}
            disabled={option.name === "delete" && this.props.isNotLeaf}
          >
            {option.text}
          </Button>
        ))}
        <div className="text-align-center w-100">
          <div className="d-flex justify-content-between w-100 text-primary">
            <div>
              {this.props.employeesText}
              :&nbsp;
            </div>
            <div>{this.props.employees}</div>
          </div>
          <div className="d-flex justify-content-between w-100 text-primary">
            <div>
              {this.props.unitsText}
              :&nbsp;
            </div>
            <div>{this.props.units}</div>
          </div>
        </div>
      </Tooltip>
    );
  }
}

HierarchyTreeTooltip.propTypes = {
  units: PropTypes.number,
  unitsText: PropTypes.string,
  functions: PropTypes.object.isRequired,
  handleClicksOutside: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  isNotLeaf: PropTypes.bool,
  keyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  employees: PropTypes.number,
  employeesText: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      text: PropTypes.string,
    }),
  ),
};

export default HierarchyTreeTooltip;
